import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrencyIsoCode } from '@coin/shared/core/util-models';
import { DisplayedCurrency } from '@coin/shared/core/util-enums';
import { CurrencyConversionService } from '@coin/shared/core/data-access';

@Pipe({ name: 'fxRate', standalone: true })
export class FxRatePipe implements PipeTransform {
  private currencyConversionService = inject(CurrencyConversionService);

  transform(
    fxDate: string | Date,
    fromCurrency: CurrencyIsoCode,
    toCurrency: CurrencyIsoCode = DisplayedCurrency.EUR,
    forceConversion?: boolean
  ): Observable<number> {
    return this.currencyConversionService.getFxRate(
      { date: fxDate instanceof Date ? fxDate.toISOString() : fxDate, from: fromCurrency, to: toCurrency },
      forceConversion
    );
  }
}
